import { useFeatureFlag } from '@app/helpers/hooks'
import { FeatureFlagName } from '@app/services/featureFlags/types'

// Rollout switch: the sheet stays hidden until the flag is on for the environment.
export const useIsFormulaSheetEnabled = (): boolean => useFeatureFlag(FeatureFlagName.student_experience_formula_sheet)
